import { JSX, useEffect, useRef, useState } from "react";
import TooltipWrapper from "@app/shared/TooltipWrapper";

interface EllipsisTooltipProps {
  width?: string;
  text: string;
}

const EllipsisTooltip = (props: EllipsisTooltipProps): JSX.Element => {
  const ref: React.RefObject<HTMLDivElement> = useRef(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  useEffect(() => {
    if (ref?.current?.offsetWidth < ref?.current?.scrollWidth) {
      setIsEllipsisActive(true);
    }
  }, [ref?.current]);

  return (
    <TooltipWrapper
      containerClassName="d-block ellipsis-tooltip"
      position={"bottom"}
      text={isEllipsisActive ? props.text : ""}
      triggerWidth="100%"
    >
      <div className="ellipsis" style={{ width: props.width }} ref={ref}>
        {props.text}
      </div>
    </TooltipWrapper>
  );
}

export { EllipsisTooltip };